export default __webpack_public_path__ + "static/media/ic_plus.d0139a7c.svg";